export const authConstants = {
  REGISTER_REQUEST: 'USER_REGISTER_REQUEST',
  REGISTER_SUCCESS: 'USER_REGISTER_SUCCESS',
  REGISTER_FAILURE: 'USER_REGISTER_FAILURE',

  LOGIN_REQUEST: 'USER_LOGIN_REQUEST',
  LOGIN_SUCCESS: 'USER_LOGIN_SUCCESS',
  LOGIN_FAILURE: 'USER_LOGIN_FAILURE',

  FORGOTPASSWORD_REQUEST: 'USER_FORGOTPASSWORD_REQUEST',
  FORGOTPASSWORD_SUCCESS: 'USER_FORGOTPASSWORD_SUCCESS',
  FORGOTPASSWORD_FAILURE: 'USER_FORGOTPASSWORD_FAILURE',

  LOGOUT: 'USER_LOGOUT',

  GET_USER_CURRENT_STORAGE: 'USER_CURRENT_STORAGE',

  GETALL_REQUEST: 'USER_GETALL_REQUEST',
  GETALL_SUCCESS: 'USER_GETALL_SUCCESS',
  GETALL_FAILURE: 'USER_GETALL_FAILURE',

  DELETE_REQUEST: 'USER_DELETE_REQUEST',
  DELETE_SUCCESS: 'USER_DELETE_SUCCESS',
  DELETE_FAILURE: 'USER_DELETE_FAILURE'
}